// extracted by mini-css-extract-plugin
module.exports = {"MainPage":"page_MainPage__1eoSs"};